import CodeEditor from "../../../codeEditor"

export const JavascriptSnippetSettings = (
  { settings: { value = "" } = {}, onChange = (settings) => {} },
  sources,
) => {
  return (
    <div className="relative h-[600px] w-[600px]">
      <CodeEditor
        value={value}
        onChange={(value) => onChange({ value })}
        context={sources}
      />
    </div>
  )
}
